import {SvgIcon} from "@material-ui/core";
import React from "react";
import { ReactComponent as SuggestedSVG } from '../../assets/images/hand-holding-up-a-bulb.svg';
import { ReactComponent as RatingSVG } from '../../assets/images/rating.svg';
import { ReactComponent as ChildSVG } from '../../assets/images/childIcon.svg';
import { ReactComponent as ParentSVG } from '../../assets/images/parentIcon.svg';
import { ReactComponent as SubtractiveSVG } from '../../assets/images/puzzleIcon.svg';
import { ReactComponent as AdditiveSVG } from '../../assets/images/puzzlePlusIcon.svg'
import { ReactComponent as AlternateSVG } from '../../assets/images/alternateIcon.svg'
import { ReactComponent as ZeroSVG } from '../../assets/images/number19-svgrepo-com.svg'
import { ReactComponent as OneSVG } from '../../assets/images/number10-svgrepo-com.svg'
import { ReactComponent as TwoSVG } from '../../assets/images/number11-svgrepo-com.svg'
import { ReactComponent as ThreeSVG } from '../../assets/images/number12-svgrepo-com.svg'
import { ReactComponent as FourSVG } from '../../assets/images/number13-svgrepo-com.svg'
import { ReactComponent as FiveSVG } from '../../assets/images/number14-svgrepo-com.svg'
import { ReactComponent as SixSVG } from '../../assets/images/number15-svgrepo-com.svg'
import { ReactComponent as MailSVG } from '../../assets/images/mail-svgrepo-com.svg'
import { ReactComponent as UnreadMailSVG } from '../../assets/images/unread-mail-svgrepo-com.svg'
import { ReactComponent as MergeChildSVG } from '../../assets/images/merged_child.svg'
import { ReactComponent as MergeParentOneSVG } from '../../assets/images/merged_is_first_parent.svg'
import { ReactComponent as MergeParentTwoSVG } from '../../assets/images/merged_is_second_parent.svg'
import { ReactComponent as MergeBlueSVG } from '../../assets/images/merged_blue.svg'
// import { ReactComponent as MiniMergeSVG } from '../../assets/images/mini-merge.svg'



export const SuggestedIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <SuggestedSVG />
        </SvgIcon>
    );
};

export const RatingIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <RatingSVG/>
        </SvgIcon>
    )
}

export const ChildIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <ChildSVG/>
        </SvgIcon>
    )
}

export const ParentIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <ParentSVG/>
        </SvgIcon>
    )
}

export const SubtractiveIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <SubtractiveSVG/>
        </SvgIcon>
    )
}

export const AdditiveIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <AdditiveSVG/>
        </SvgIcon>
    )
}

export const AlternateIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <AlternateSVG/>
        </SvgIcon>
    )
}

export const ZeroIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <ZeroSVG/>
        </SvgIcon>
    )
}

export const OneIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <OneSVG/>
        </SvgIcon>
    )
}

export const TwoIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <TwoSVG/>
        </SvgIcon>
    )
}

export const ThreeIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <ThreeSVG/>
        </SvgIcon>
    )
}

export const FourIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <FourSVG/>
        </SvgIcon>
    )
}

export const FiveIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <FiveSVG/>
        </SvgIcon>
    )
}

export const SixIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <SixSVG/>
        </SvgIcon>
    )
}

export const Notifications = (props) => {
    return (
        <SvgIcon  {...props}>
            <MailSVG/>
        </SvgIcon>
    )
}

export const UnreadNotifications = (props) => {
    return (
        <SvgIcon  {...props}>
            <UnreadMailSVG/>
        </SvgIcon>
    )
}

export const MergeChildIcon = (props) => {
    return (
        <SvgIcon  {...props}>
            <MergeChildSVG/>
        </SvgIcon>
    )
}

export const MergeParentOneIcon = (props) => {
    return (
        <SvgIcon  {...props}>
            <MergeParentOneSVG/>
        </SvgIcon>
    )
}

export const MergeParentTwoIcon = (props) => {
    return (
        <SvgIcon  {...props}>
            <MergeParentTwoSVG/>
        </SvgIcon>
    )
}

export const MergeBlueIcon = (props) => {
    return (
        <SvgIcon {...props}>
            <MergeBlueSVG/>
        </SvgIcon>
    )
}

// export const MiniMergeIcon = (props) => {
//     return (
//         <SvgIcon {...props}>
//             <MiniMergeSVG/>
//         </SvgIcon>
//     )
// }